export const getAllsureHomeClaim = (state) =>
  state.allsureHomeClaim;
